<template>
  <div>

    <!-- 会员头部封装 -->
      <Member></Member>
    <div class="container-xl">
      <div class="sign">
        <img src="../img/brandlogo3.png" alt="" />
        <van-field v-model="phone" label="帐号" placeholder="请输入邮箱" />
        <van-field
          v-model="password"
          type="password"
          label="密码"
          placeholder="请输入密码"
        />
        <div style="margin-top: 40px">
          <router-link to="/forget">忘记密码？</router-link><br />
        </div>
        <button @click="sign">登入</button>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from "@/api/outpatient";

import Member from "@/components/Member.vue";

export default {
  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/sign'
    },{
      rel:'alternate',
      href:'https://mybeame.com/sign',
      hrefLang:'x-default'
    }
    ]
  },

  components: {
    Member,
  },
  data() {
    return {
      visible: false,
      dialogTableVisible: false,
      phone: "",
      password: "",
      uresData: {},
    };
  },
  mounted() {},
  methods: {
    //登录请求事件
    sign() {
      if (this.phone == "") {
        this.$message({
          message: "请输入邮箱",
          type: "warning",
        });
        return;
      }
      if (this.password == "") {
        this.$message({
          message: "请输入密码",
          type: "warning",
        });
        return;
      }
      this.subData = Object.assign(this.uresData);
      var uresData = {
        phone: this.phone,
        password: this.password,
      };
      // 发送请求
      login(uresData).then((res) => {
        if (res.code == 200) {
          localStorage.setItem("data", res.data);
          this.$router.push("/personal");
        }
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.top {
  width: 100%;
  padding: 5px 0;
  background: #00e467;
}
.logo {
  display: flex;
  align-items: center;
}
.logo > a {
  margin-left: 5%;
}
.logo > a > img {
  width: 28px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.logo > h3 {
  width: 80%;
  font-weight: 700;
  font-size: 21px;
  margin: 0;
}
.head-2 {
  float: right;
  display: flex;
  align-items: center;
}
.head-2 > div {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.head-2 > h3 {
  margin: 5px 0 0 0;
  font-size: 21px;
}
.head-tou-img {
  width: 35px;
  margin-top: 2px;
}
.el-button {
  padding: 0;
}
.sign {
  text-align: center;
}
.sign > img {
  width: 287px;
  margin-top: 100px;
  margin-bottom: 50px;
}
.van-cell {
  width: 40%;
  border: 2px solid #00e467;
  border-radius: 10px;
  margin: auto;
  margin-top: 20px;
}
.van-radio-group--horizontal {
  font-size: 15px !important;
  font-weight: 700;
}
.sign > button {
  width: 40%;
  padding: 10px 0;
  border: none;
  margin-top: 15px;
  font-size: 19px;
  font-weight: 600;
  background: #00e467;
  border-radius: 0px 20px 0px 0px;
}


h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {

}
@media all and (max-width: 570px) {

  .sign > img {
    width: 50%;
  }
  .van-cell {
    width: 80%;
  }
  .sign > button {
    width: 80%;
  }
}
</style>